import { render, staticRenderFns } from "./problem-modal.vue?vue&type=template&id=26e74b19"
import script from "./problem-modal.vue?vue&type=script&lang=js"
export * from "./problem-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports